import React from 'react';
import { Grid, Typography, Box } from '@mui/material';

export default function CaseStudy({ title, body, image, imageAlt, reverse }) {
  return (
    <Grid
      container
      spacing={4}
      alignItems="center"
      sx={{ py: 4 }}
    >
      {image && (
        <Grid item xs={12} md={6} order={{ xs: 1, md: reverse ? 2 : 1 }}>
          <Box
            component="img"
            src={image}
            alt={imageAlt || `${title} visual`}
            sx={{ width: '100%', borderRadius: 2 }}
          />
        </Grid>
      )}
      <Grid item xs={12} md={image ? 6 : 12} order={{ xs: 2, md: reverse ? 1 : 2 }}>
        <Typography variant="h5" component="h3" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: body }} />
      </Grid>
    </Grid>
  );
}
